<!-- 任务点排名 -->
<template>
  <div ref="wholePage">

    <a-card title="工单创建走势报表" size="small">
      <div id="ticket-create-trend" :style="{ height: height, width: width }" />
    </a-card>
    <div v-if="data">
      <ticket-list-modal ref="ticketListModal" :task-list="ticketList" :user-list="userList" :tag-list="tagList" />
    </div>
  </div>
</template>
<script>
import { ticketDailyTrend } from '@/api/data/ticket';
import TicketListModal from '@/pages/data/ticket/components/TicketListModal';
export default {
  components: { TicketListModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '360px'
    },
    userList: {
      type: Array,
      default: null
    },
    tagList: {
      type: Array,
      default: null
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      data: [],
      backData: [],
      solveData: [],
      solveLaterData: [],
      needTimesData: [],
      seriesIndex: 0,
      ticketList: [],
      modalVisible: false,
      tableData: [],
      rate_option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
        ]
      }
    };
  },
  watch: {
    filterForm() {
      this.getData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart_rate.resize();
      }, 200);
    }
  },
  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/legend');
    require('echarts/lib/chart/bar');
    require('echarts/lib/chart/line');
    require('echarts/lib/component/markLine');
    this.myChart_rate = echarts.init(document.getElementById('ticket-create-trend'));
    this.myChart_rate.on('click', param => {
      this.seriesIndex = param.seriesIndex;
    });
    this.myChart_rate.getZr().on('click', param => {
      const pointInPixel = [param.offsetX, param.offsetY];
      // 判断给定的点是否在指定的坐标系或者系列上
      if (this.myChart_rate.containPixel('grid', pointInPixel)) {
        // 获取到点击的 x轴 下标  转换为逻辑坐标
        const index = this.myChart_rate.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
        // const y = param.target.__ec_inner_7.seriesIndex;
        setTimeout(() => {
          this.onDetail(index, this.seriesIndex);
        }, 10); // 延迟 200 毫秒
      }
    });
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart_rate.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart_rate.setOption(this.rate_option, true);
      this.$nextTick(() => {
        this.myChart_rate.resize();
      });
    },
    onDetail(index, y) {
      this.index = index;
      const _time = this.rate_option.xAxis[0].data[index];
      if (y === 0) {
        this.ticketList = this.data[_time];
      } else if (y === 1) {
        this.ticketList = this.backData[index];
      } else if (y === 2) {
        this.ticketList = this.solveData[index];
      } else if (y === 3) {
        this.ticketList = this.solveLaterData[index];
      } else if (y === 4) {
        this.ticketList = this.needTimesData[index];
      }
      setTimeout(() => {
        this.$refs.ticketListModal.open();
      }, 10); // 延迟 200 毫秒
    },
    getData() {
      this.loading = true;
      ticketDailyTrend(this.filterForm)
        .then(res => {
          this.rate_option.series = [{
            name: '工单创建趋势',
            type: 'line',
            emphasis: {
              focus: 'series'
            },
            data: Object.values(res.data.ySerious).map(item => item.length),
            label: {
              formatter: '{c}%'
            }
          }, {
            name: '工单打回趋势',
            type: 'line',
            emphasis: {
              focus: 'series'
            },
            data: Object.values(res.data.ySerious).map(item => {
              return (item.filter(t => t.status === 6)).length;
            }),
            label: {
              formatter: '{c}%'
            }
          }, {
            name: '工单解决趋势',
            type: 'line',
            emphasis: {
              focus: 'series'
            },
            data: Object.values(res.data.ySerious).map(item => {
              return (item.filter(t => t.status === 4)).length;
            }),
            label: {
              formatter: '{c}%'
            }
          }, {
            name: '后续优化工单趋势',
            type: 'line',
            emphasis: {
              focus: 'series'
            },
            data: Object.values(res.data.ySerious).map(item => {
              return (item.filter(t => t.status === 5)).length;
            }),
            label: {
              formatter: '{c}%'
            }
          }, {
            name: '工单要求补充信息趋势',
            type: 'line',
            emphasis: {
              focus: 'series'
            },
            data: Object.values(res.data.ySerious).map(item => {
              return (item.filter(t => t.needTimes > 0)).length;
            }),
            label: {
              formatter: '{c}%'
            }
          }];
          this.data = res.data.ySerious;
          this.backData = Object.values(res.data.ySerious).map(item => {
            return (item.filter(t => t.status === 6));
          });
          this.solveData = Object.values(res.data.ySerious).map(item => {
            return (item.filter(t => t.status === 4));
          });
          this.solveLaterData = Object.values(res.data.ySerious).map(item => {
            return (item.filter(t => t.status === 5));
          });
          this.needTimesData = Object.values(res.data.ySerious).map(item => {
            return (item.filter(t => t.needTimes > 0));
          });
          this.rate_option.xAxis[0].data = res.data.xSerious;
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    close() {
      this.detailVisible = false;
    }
  }
};
</script>

    <style lang="less" scoped>
    .customer-card {
      margin-bottom: 10px;
    }
    </style>

